export default __webpack_public_path__ + "de4e915877500afe27d3c68d8736eb64.png";